export enum ProcessingClassSubType {
  Hospital = 'Hospital',
  Pharmacy = 'Pharmacy',
  DayToDay = 'Day to Day',
  DiseaseManagement = 'Disease Management'
}

// Important! Order of following enum depends upon defined in DB `processing_sub_class_id` COLUMN
export enum ProcessingClassSubTypeDBMapping {
  Hospital = 1,
  Pharmacy = 2,
  DayToDay = 3,
  DiseaseManagement = 4,
}


export enum ClmRoutes {
  AddFuneralCase = '/claim-management/add-funeral-case',
  AddHospitalCase = '/claim-management/add-hospital-case',
  AddPharmacyCase = '/claim-management/add-pharmacy-case',
  EditFuneralCase = '/claim-management/edit-funeral-case',
  EditHospitalCase = '/claim-management/edit-hospital-case',
  EditPharmacyCase = '/claim-management/edit-pharmacy-case',
}
